/** Aligns with PluginManagement — single-plugin GET may omit `name`; list endpoint includes it. */
export function pickPluginDisplayNameFromPayload(data: unknown): string | null {
	if (!data || typeof data !== "object") return null;
	const o = data as Record<string, unknown>;
	for (const key of ["name", "pluginName", "displayName"] as const) {
		const v = o[key];
		if (typeof v === "string" && v.trim().length > 0) return v.trim();
	}
	return null;
}

export function pickIsCustomerManagedFromDetailPayload(data: unknown): boolean | null {
	if (!data || typeof data !== "object") return null;
	const v = (data as Record<string, unknown>).isCustomerManaged;
	return typeof v === "boolean" ? v : null;
}

/** Same shape as platforms response in `PluginManagement.initPluginManagement`. */
export function findPluginMetaInPlatformsPayload(
	platforms: unknown,
	pluginId: string,
): { name: string | null; isCustomerManaged: boolean | null } {
	if (!Array.isArray(platforms)) return { name: null, isCustomerManaged: null };
	const idStr = String(pluginId);
	for (const platform of platforms) {
		const plugins = (platform as { plugins?: unknown }).plugins;
		if (!Array.isArray(plugins)) continue;
		for (const plugin of plugins) {
			if (!plugin || typeof plugin !== "object") continue;
			const p = plugin as { id?: unknown; name?: unknown; isCustomerManaged?: unknown };
			if (String(p.id) !== idStr) continue;
			const name = typeof p.name === "string" && p.name.trim().length > 0 ? p.name.trim() : null;
			const isCustomerManaged =
				typeof p.isCustomerManaged === "boolean" ? p.isCustomerManaged : null;
			return { name, isCustomerManaged };
		}
	}
	return { name: null, isCustomerManaged: null };
}

export function findPluginNameInPlatformsPayload(platforms: unknown, pluginId: string): string | null {
	return findPluginMetaInPlatformsPayload(platforms, pluginId).name;
}
